// src/components/pages/RecruitmentPage.tsx
import React from 'react';
// ↓↓↓ 実際のプロジェクト構造に合わせてパスを調整してください ↓↓↓
import {
    PageContainer,
    CommonPageTitle,
    IntroText,
    SubHeading,
    ContentParagraph,
    EmphasisText,
    StyledList,
    StyledListItem,
    CallToActionText, // 必要に応じて追加
} from '../styles/GlobalStyles'; // GlobalStylesから汎用スタイルをインポート
import styled from '@emotion/styled'; // このページ固有のスタイルのため

// このページ固有のスタイル
const SectionWrapper = styled.section`
  margin-bottom: 40px;
  padding: 25px;
  background-color: rgba(255, 255, 255, 0.02); // わずかに背景色をつける
  border-radius: 8px;
  border: 1px solid rgba(0, 255, 255, 0.1); // 細い境界線
`;

const JobRoleWrapper = styled.div`
  margin-top: 25px;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px dashed rgba(0, 255, 255, 0.2); // 職種間の区切り

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

const JobRoleTitle = styled.h4`
  font-size: 1.5em;
  color: #00e5ff; // 強調色
  margin-bottom: 15px;
`;

const DetailList = styled(StyledList)`
  margin-top: 8px;
`;

const DetailListItem = styled(StyledListItem)`
  text-align: left; // 左揃え
  font-size: 1em; // 少し小さめに
  &:before {
    content: '›'; // シンプルなマーカーに変更
    font-size: 1.4em;
    line-height: 0.8;
  }
`;

const SalaryDetail = styled(ContentParagraph)`
  margin-top: 5px;
  margin-bottom: 8px;
  font-size: 1em;
`;


const RecruitmentPage: React.FC = () => {
    return (
        <PageContainer
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
        >
            <CommonPageTitle>採用情報</CommonPageTitle>
            <IntroText>LudyWorksでは一緒に働くメンバーを募集しています。</IntroText>

            {/* 提携フリーランス セクション */}
            <SectionWrapper>
                <SubHeading>提携フリーランス</SubHeading>
                <ContentParagraph>
                    柔軟な働き方で、あなたのスキルを最大限に活かしませんか？ LudyWorksでは、様々なプロジェクトで協力いただけるフリーランスの専門家を求めています。
                </ContentParagraph>

                <JobRoleTitle>基本情報・福利厚生</JobRoleTitle>
                <DetailList>
                    <DetailListItem>完全成果報酬型（コアタイム無し）</DetailListItem>
                    <DetailListItem>大企業並みの充実の福利厚生が受けられる (※適用条件あり)</DetailListItem>
                    <DetailListItem>NetFlixが見放題！</DetailListItem>
                    <DetailListItem>1000以上のe-learningが受講し放題！資格取得やスキルアップにつながる！</DetailListItem>
                    <DetailListItem>Amazonギフト券が2.5%OFFで購入可能！</DetailListItem>
                    <DetailListItem>その他スポーツクラブやネットショップ、全国各地の旅館やホテルがお得に利用できます！</DetailListItem>
                    <DetailListItem>クライアントから保守・運用契約の獲得で安定した収入源を作れる！</DetailListItem>
                </DetailList>

                <JobRoleWrapper>
                    <JobRoleTitle>ソフトウェアエンジニア</JobRoleTitle>
                    <EmphasisText>募集要項：</EmphasisText>
                    <DetailList>
                        <DetailListItem>TypeScript＋Reactでのフロントエンド開発, pythonでのバックエンド開発, GCPの構築・運用経験, AWSの構築運用経験 いずれか２つを３年以上</DetailListItem>
                        <DetailListItem>業務としてのコーディング経験が３年以上ある方（JavaScript, pythonなどWEB系経験者歓迎, 趣味やスクールでの経験は除く）</DetailListItem>
                        <DetailListItem>要件定義から保守運用まで自身の作品に長く携わりたい方</DetailListItem>
                        <DetailListItem>新しいことにチャレンジすることが好きな方</DetailListItem>
                        <DetailListItem>その他、売り込みたいスキルがある方は当てはまらなくてもご相談ください！</DetailListItem>
                    </DetailList>
                    <EmphasisText>給与：</EmphasisText>
                    <SalaryDetail>完全成果報酬型</SalaryDetail>
                    <DetailList>
                        <DetailListItem>開発契約：売上の10%〜30%（スキルにより変動）</DetailListItem>
                        <DetailListItem>保守契約：売上の5%〜10%（スキルにより変動）</DetailListItem>
                    </DetailList>
                </JobRoleWrapper>

                <JobRoleWrapper>
                    <JobRoleTitle>営業職</JobRoleTitle>
                    <EmphasisText>募集要項：</EmphasisText>
                    <DetailList>
                        <DetailListItem>営業職での実務経験（目安３年以上）</DetailListItem>
                        <DetailListItem>在籍中もしくは過去在籍の社内で営業成績１位獲得の経験</DetailListItem>
                        <DetailListItem>数字に強く、クライアントとの折衝を円滑に進められる方</DetailListItem>
                        <DetailListItem>新しいことにチャレンジすることが好きな方</DetailListItem>
                    </DetailList>
                    <EmphasisText>給与：</EmphasisText>
                    <SalaryDetail>完全成果報酬型</SalaryDetail>
                    <DetailList>
                        <DetailListItem>新規契約：売上の10%〜50%（案件規模により変動）</DetailListItem>
                        <DetailListItem>契約更新：売上の20%</DetailListItem>
                    </DetailList>
                </JobRoleWrapper>

                <JobRoleWrapper>
                    <JobRoleTitle>デザイナー</JobRoleTitle>
                    <EmphasisText>募集要項：</EmphasisText>
                    <DetailList>
                        <DetailListItem>業務としてのデザイン経験が３年以上ある方（広告・LPなどWEB系経験者歓迎, 趣味やスクールでの経験は除く）</DetailListItem>
                        <DetailListItem>感覚的ではなく、配信の結果などを分析して理論的にデザインを捉えることができる方</DetailListItem>
                        <DetailListItem>新しいことにチャレンジすることが好きな方</DetailListItem>
                    </DetailList>
                    <EmphasisText>給与：</EmphasisText>
                    <SalaryDetail>完全成果報酬型</SalaryDetail>
                    <DetailList>
                        <DetailListItem>新規案件：売上の10%</DetailListItem>
                        <DetailListItem>保守案件：売上の10%</DetailListItem>
                    </DetailList>
                </JobRoleWrapper>
            </SectionWrapper>

            {/* 正社員 セクション */}
            <SectionWrapper>
                <SubHeading>正社員</SubHeading>
                <ContentParagraph>
                    LudyWorksの成長を共に牽引し、安定した環境でチャレンジを続けたい方を募集しています。私たちと一緒に、未来を創りませんか？
                </ContentParagraph>

                <JobRoleTitle>基本情報・待遇</JobRoleTitle>
                <DetailList>
                    <DetailListItem>完全週休３日（水土日・祝日休み）</DetailListItem>
                    <DetailListItem>年間休日１７０日（2023年実績）</DetailListItem>
                    <DetailListItem>有給・誕生日休暇あり</DetailListItem>
                    <DetailListItem>１日の所定労働時間６.５時間</DetailListItem>
                    <DetailListItem>フルリモート勤務（不要不急の出社は認めません）</DetailListItem>
                    <DetailListItem>残業非推奨（不要不急の残業は認めません）</DetailListItem>
                    <DetailListItem>月の平均残業時間５時間以下（2023年実績）</DetailListItem>
                </DetailList>

                <JobRoleWrapper>
                    <JobRoleTitle>ソフトウェアエンジニア</JobRoleTitle>
                    <EmphasisText>募集要項：</EmphasisText>
                    <DetailList>
                        <DetailListItem>当社システム開発案件の受注実績のある方（目安３件以上）</DetailListItem>
                        <DetailListItem>業務としてのコーディング経験が３年以上ある方（JavaScript, PHPなどWEB系経験者歓迎, 趣味やスクールでの経験は除く）</DetailListItem>
                        <DetailListItem>要件定義から保守運用まで自身の作品に長く携わりたい方</DetailListItem>
                        <DetailListItem>新しいことにチャレンジすることが好きな方</DetailListItem>
                    </DetailList>
                    <EmphasisText>給与：</EmphasisText>
                    <DetailList>
                        <DetailListItem>基本給：200,000円（学歴不問）</DetailListItem>
                        <DetailListItem>技能手当：0〜100,000円（スキルにより変動）</DetailListItem>
                        <DetailListItem>役職手当：0〜100,000円（役職により変動）</DetailListItem>
                        <DetailListItem>賞与：年0〜2回　2〜6ヶ月分/回（業績・貢献度により変動）</DetailListItem>
                    </DetailList>
                </JobRoleWrapper>

                <JobRoleWrapper>
                    <JobRoleTitle>デザイナー</JobRoleTitle>
                    <EmphasisText>募集要項：</EmphasisText>
                    <DetailList>
                        <DetailListItem>当社デザイン案件の受注実績のある方（目安３件以上）</DetailListItem>
                        <DetailListItem>業務としてのデザイン経験が３年以上ある方（広告・LPなどWEB系経験者歓迎, 趣味やスクールでの経験は除く）</DetailListItem>
                        <DetailListItem>感覚的ではなく、配信の結果などを分析して理論的にデザインを捉えることができる方</DetailListItem>
                        <DetailListItem>新しいことにチャレンジすることが好きな方</DetailListItem>
                    </DetailList>
                    <EmphasisText>給与：</EmphasisText>
                    <DetailList>
                        <DetailListItem>基本給：180,000円（学歴不問）</DetailListItem>
                        <DetailListItem>技能手当：0〜100,000円（スキルにより変動）</DetailListItem>
                        <DetailListItem>役職手当：0〜100,000円（役職により変動）</DetailListItem>
                        <DetailListItem>賞与：年0〜2回　2〜6ヶ月分/回（業績・貢献度により変動）</DetailListItem>
                    </DetailList>
                </JobRoleWrapper>

                <JobRoleWrapper>
                    <JobRoleTitle>広告コンサルタント</JobRoleTitle>
                    <EmphasisText>募集要項：</EmphasisText>
                    <DetailList>
                        <DetailListItem>当社広告配信案件の受注実績のある方（目安３件以上）</DetailListItem>
                        <DetailListItem>業務としての広告配信経験が３年以上ある方（趣味やスクールでの経験は除く）</DetailListItem>
                        <DetailListItem>数字に強く、クライアントとの折衝を円滑に進められる方</DetailListItem>
                        <DetailListItem>新しいことにチャレンジすることが好きな方</DetailListItem>
                    </DetailList>
                    <EmphasisText>給与：</EmphasisText>
                    <DetailList>
                        <DetailListItem>基本給：180,000円（学歴不問）</DetailListItem>
                        <DetailListItem>技能手当：0〜100,000円（スキルにより変動）</DetailListItem>
                        <DetailListItem>役職手当：0〜100,000円（役職により変動）</DetailListItem>
                        <DetailListItem>賞与：年0〜2回　2〜6ヶ月分/回（業績・貢献度により変動）</DetailListItem>
                    </DetailList>
                </JobRoleWrapper>
            </SectionWrapper>

            {/* お問い合わせセクション */}
            <SectionWrapper>
                <SubHeading>お問い合わせ</SubHeading>
                <ContentParagraph>
                    ご興味をお持ちいただけましたら、以下の連絡先までお気軽にお問い合わせください。
                    <br />
                    皆様からのご応募を心よりお待ちしております。
                </ContentParagraph>
                <StyledList>
                    <StyledListItem>
                        <EmphasisText>メールアドレス：</EmphasisText> main@ludyworks.com
                    </StyledListItem>
                    <StyledListItem>
                        <EmphasisText>採用担当：</EmphasisText> 木田 貴之
                    </StyledListItem>
                </StyledList>
                {/* 必要に応じてCallToActionTextを追加 */}
                {/* <CallToActionText>エントリーフォームはこちら (仮)</CallToActionText> */}
            </SectionWrapper>
        </PageContainer>
    );
};

export default RecruitmentPage;